import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { footerContent } from '../../contentData/footer';
import CookieConsentTab from '../commons/ui/cookie-consent';

export default function FooterMobile() {
  return (
    <>
      <Box sx={{ fontSize: 12, p: 2, pl: 4 }}>
        <Box mb={0.5}>
          <Typography component="div" sx={{ fontSize: 14, fontWeight: 700 }}>
            {footerContent.contactUs.title}
          </Typography>
          {footerContent.contactUs.email.title}{' '}
          <a
            target="_blank"
            href={footerContent.contactUs.email.link}
            style={{ textDecoration: 'none', color: '#FFFFFF' }}>
            {footerContent.contactUs.email.text}
          </a>
        </Box>
        <Box mb={1.5}>
          {footerContent.line.title}{' '}
          <a target="_blank" href={footerContent.line.link} style={{ textDecoration: 'none', color: '#FFFFFF' }}>
            {footerContent.line.text}
          </a>
        </Box>
        <Box mb={0.5}>
          <Typography component="span" sx={{ fontSize: 14, fontWeight: 700, mr: 6 }}>
            {footerContent.businessHours.title}
          </Typography>
          {footerContent.businessHours.text}
        </Box>
        <Box mb={1.5}>
          <Typography component="span" sx={{ fontSize: 14, fontWeight: 700, mr: 2 }}>
            {footerContent.customerService.title}
          </Typography>
          {footerContent.customerService.text}
        </Box>

        <Box mb={1}>
          <Link
            to={footerContent.privacy.link}
            style={{ textDecoration: 'none', color: '#FFFFFF', marginRight: '20px' }}>
            {footerContent.privacy.text}
          </Link>
          <Link to={footerContent.cookie.link} style={{ textDecoration: 'none', color: '#FFFFFF' }}>
            {footerContent.cookie.text}
          </Link>
        </Box>

        <Box sx={{ fontSize: 12 }}>
          {footerContent.license.text} {footerContent.version}
        </Box>
      </Box>

      <CookieConsentTab />
    </>
  );
}
